import React, { useState } from 'react'
import { Link, NavLink } from 'react-router-dom'

const Footer = () => {

  return (
    <>
        <footer>
            <div className="container">
                <div className="row">
                  <div className="col-md-4">
                    <div className="heading  fs-4">
                      About us
                    </div>
                          <p className=''>Your website isn’t just a screen—it’s your brand’s voice, personality, and first handshake. At Website Drona, we craft digital experiences that feel intuitive, look stunning, and deliver measurable impact.</p>
                    <div class="socialIcon position-relative" style={{float:'left'}}>
                              <img src="./images/socialJarNew.png" class="img-responsive footer-jar" alt='Social Jar Logo' width="90"/>
                        <div className='social-bar'>
                            <a href="https://www.facebook.com/websitedrona" target="_blank">
                                <i class="fa-brands fa-facebook-f footer-fb hvr-footer-social"></i>
                            </a>
                            <a href="https://www.instagram.com/websitedrona/" target="_blank">
                                <center><i class="fa-brands fa-instagram footer-gplus hvr-footer-social"></i></center>
                            </a>
                            <a href="https://www.linkedin.com/company/websitedrona/" target="_blank">
                                <i class="fa-brands fa-linkedin-in footer-linkedin hvr-footer-social"></i>
                            </a>
                            <a href="https://twitter.com/Website_drona" target="_blank">
                                <i class="fa-brands fa-x-twitter footer-tw hvr-footer-social"></i>
                            </a>
                            <a href="#" class="small-b small-b-1 hvr-footer-social"></a>
                            <a href="#" class="small-b small-b-2 hvr-footer-social"></a>
                            <a href="#" class="small-b small-b-3 hvr-footer-social"></a>
                            <a href="#" class="small-b small-b-4 hvr-footer-social"></a>
                            <a href="#" class="small-b small-b-5 hvr-footer-social"></a>
                            <a href="#" class="small-b small-b-6 hvr-footer-social"></a>
                            <a href="#" class="tiny-b tiny-b-1 hvr-footer-social"></a>
                            <a href="#" class="tiny-b tiny-b-2 hvr-footer-social"></a>
                            <a href="#" class="tiny-b tiny-b-3 hvr-footer-social"></a>
                            <a href="#" class="tiny-b tiny-b-4 hvr-footer-social"></a>
                            <a href="#" class="tiny-b tiny-b-5 hvr-footer-social"></a>
                            <a href="#" class="tiny-b tiny-b-6 hvr-footer-social"></a>
                            <a href="#" class="tiny-b tiny-b-7 hvr-footer-social"></a>
                            <a href="#" class="tiny-b tiny-b-8 hvr-footer-social"></a>
                            <a href="#" class="tiny-b tiny-b-9 hvr-footer-social"></a>
                            <a href="#" class="tiny-b tiny-b-10 hvr-footer-social"></a>
                            <a href="#" class="tiny-b tiny-b-11 hvr-footer-social"></a>
                            <a href="#" class="tiny-b tiny-b-12 hvr-footer-social"></a>
                        </div>
                              <div style={{ float: 'right', marginLeft: '15px' }}>
                                  <img src="./images/shopify.png" height="110" width="110" alt='Wix Partner Logo' />
                              </div>
                              <div style={{ float: 'right', marginLeft: '15px' }}>
                                  <img src="./images/EN_icon_small.png" height="100" width="100" alt='Wix Partner Logo' />
                              </div>
                    </div>
                  </div>
                 
                  <div className="col-md-3">
                          <img src="./images/idea2.gif" alt="Digital Marketing Idea " />
                   
                  </div>
                  <div className="col-md-2 ps-3">
                    <div className="heading  fs-4">
                      Important Links
                    </div>
                      <ul className='p-0 usefull_links'>
                        <li><NavLink to='/'>Home</NavLink></li>
                        <li><NavLink to='/website-designing'>Website Designing</NavLink></li>
                        <li><NavLink to='/branding'>Branding</NavLink></li>
                        <li><NavLink to='/who-we-are'>Who we are</NavLink></li>
                        <li><NavLink to='/contact-us'>Contact Us</NavLink></li>
                              <li><NavLink to='/portfolio'>Portfolio</NavLink></li>
                              <li><NavLink to='https://blog.websitedrona.com/' target='_blank'>Blogs</NavLink></li>
                      </ul>
                  </div>
                  <div className="col-md-3">
                     <div className="heading  fs-4">
                      Contact Details
                    </div>
                    <div className="d-flex align-items-center mb-5">
                      <div className="footer_icon me-3">
                                  <img src='./images/cup.svg' alt='Cup of tea'/>
                      </div>
                              <p className=" m-0">306, Third Floor, Tower A1,
                                  Corporate Park, Sector 142,
                                  Noida, Uttar Pradesh - 201301</p>
                    </div>
                    {/* <div className="d-flex align-items-start mb-2">
                      <div className="footer_icon me-3">
                        <i className="fa-solid fa-envelope"></i>
                      </div>
                      <div>
                        <p>
                          <a className="text-white" href="mailto:sales@websitedrona.com">sales@websitedrona.com</a>
                        </p>
                      </div>
                    </div>*/}
                    <div className='d-flex gap-3 mt-4'>
                        <Link target='_blank' className='rating_btn' to='https://g.co/kgs/8kpUE8Y'><img src="./images/google_rating.png" className='w-100' alt="google rating website drona" /></Link>
                        <Link target='_blank' className='rating_btn' to=''><img src="./images/justdial.png" className='w-100' alt="justdial rating website drona" /></Link>
                    </div>
                    <div className="d-flex align-items-start mt-3">
                      <div className="me-3">
                        <i className="fa-solid fa-phone"></i>
                      </div>
                      <div>
                        <p>
                           <a style={{color:'var(--text)'}} href="tel:+0120-4382902">+0120-4382902</a>
                        </p>
                      </div>
                    </div> 
                  </div>
                </div>
            </div>
        </footer>
        <div className="footer-bottom py-3 border-top">
          <div className="container">
            <div className="d-md-flex justify-content-between">
              <p className="small m-0 text-white-50">Copyright © 2025 Website Drona</p>
                      <p className="small m-0 text-white-50">Unit of - <a className="small m-0 text-white-50" href="https://www.sagarinfotech.com/">Sagar Infotech pvt. ltd.</a></p>
            </div>
          </div>
        </div>
    </>
  )
}

export default Footer